import Ajuda from "./_ajuda";
import Authenticate from "./_authenticate";
import Colunas from "./_colunas";
import Doutrinas from "./_doutrinas";
import Home from "./_home";
import Pesquisa from "./_pesquisa";
import Privacidade from "./_privacidade";
import Produtos from "./_produtos";
import Profile from "./_profile";
import DoctrineDetails from "./_resultsDetails/_doctrineDetails";
import LegislationDetails from "./_resultsDetails/_legislationDetails";

import UserAccessLimit from "./_authenticate/_simultaneos-access/_same-user-access-limit";
import GlobalAccessLimit from "./_authenticate/_simultaneos-access/_simultanoes-access-limit";
import SSOCallback from "./_authenticate/_sso/_callback";
import SSOLogout from "./_authenticate/_sso/_logout";

import Login from "./_login";
import RegisterDependent from "./_registerDependent";
import JurisprudenceDetails from "./_resultsDetails/_jurisprudenceDetails";
import ModelDetails from "./_resultsDetails/_modelDetails";
import Sac from "./_sac";
import SearchResults from "./_searchResults";
import Sobre from "./_sobre";

export interface ProfileProps {
  children: React.ReactElement;
  footerClass?: string;
  fullHeight?: boolean;
  headerClass?: string;
  id: string;
  isModule: boolean;
  name: string;
  protectedPage?: boolean;
  showFooter?: boolean;
  showHeader?: boolean;
}

export type Page = {
  Element: React.ComponentType<ProfileProps>;
  path?: string;
  headerClass?: string;
  id: string;
  isModule?: boolean;
  name: string;
  order?: number | null;
  protectedPage?: boolean;
  showFooter?: boolean;
  showHeader?: boolean;
};

const pages: Page[] = [
  {
    Element: Authenticate,
    path: "/autenticar/:token",
    headerClass: "authenticate",
    id: "authenticate",
    isModule: false,
    name: "Autenticte",
    order: null,
    protectedPage: false,
    showFooter: false,
    showHeader: false,
  },
  {
    Element: Login,
    path: "/login",
    headerClass: "login",
    id: "Login",
    isModule: false,
    name: "login",
    order: null,
    protectedPage: false,
    showFooter: false,
    showHeader: false,
  },
  {
    Element: Login,
    path: "/entrar",
    id: "entrar",
    headerClass: "entrar",
    isModule: false,
    name: "entrar",
    order: null,
    protectedPage: true,
    showFooter: false,
    showHeader: false,
  },

  {
    Element: SSOCallback,
    path: "/sso/callback",
    headerClass: "authenticate",
    id: "sso-callback",
    isModule: false,
    name: "SSO Callback",
    order: null,
    protectedPage: false,
    showFooter: false,
    showHeader: false,
  },
  {
    Element: SSOLogout,
    path: "/sso/logout",
    headerClass: "authenticate",
    id: "sso-logout",
    isModule: false,
    name: "SSO Logout",
    order: null,
    protectedPage: false,
    showFooter: false,
    showHeader: false,
  },

  {
    Element: RegisterDependent,
    path: "/registrar",
    headerClass: "registrar",
    id: "Registrar",
    isModule: false,
    name: "registrar",
    order: null,
    protectedPage: true,
    showFooter: false,
    showHeader: false,
  },
  {
    Element: Home,
    headerClass: "home",
    id: "home",
    isModule: false,
    name: "Home",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: Profile,
    id: "perfil",
    isModule: false,
    name: "Perfil",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: Pesquisa,
    id: "pesquisa",
    isModule: false,
    name: "Pesquisa",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: SearchResults,
    id: "resultados",
    isModule: false,
    name: "Resultados",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: Sobre,
    id: "sobre",
    isModule: false,
    name: "Sobre",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: Produtos,
    id: "produtos",
    isModule: false,
    name: "Produtos",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: Colunas,
    id: "colunas",
    isModule: false,
    name: "Colunas",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: DoctrineDetails,
    id: "doutrina",
    path: "/doutrinas/:id",
    isModule: false,
    name: "Doutrina",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: JurisprudenceDetails,
    id: "jurisprudencia",
    path: "/jurisprudencia/:id",
    isModule: false,
    name: "jurisprudencia",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: Doutrinas,
    id: "doutrinas",
    isModule: false,
    name: "Doutrinas",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: ModelDetails,
    id: "modelsDetail",
    path: "/modelos/:id",
    isModule: false,
    name: "Modelo",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: LegislationDetails,
    id: "legislação",
    path: "/legislacao/:id",
    isModule: false,
    name: "Legislação",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: Ajuda,
    id: "ajuda",
    isModule: false,
    name: "Ajuda",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: Privacidade,
    id: "privacidade",
    isModule: false,
    name: "Privacidade",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: Sac,
    id: "sac",
    isModule: false,
    name: "SAC",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: GlobalAccessLimit,
    id: "limite-acessos",
    isModule: false,
    name: "Limite global de acessos simultâneos",
    order: null,
    protectedPage: false,
    showFooter: false,
    showHeader: false,
  },
  {
    Element: UserAccessLimit,
    id: "limite-acessos-usuario",
    isModule: false,
    name: "Limite acessos simultâneos do usuário alcançado",
    order: null,
    protectedPage: false,
    showFooter: false,
    showHeader: false,
  },
];

export default pages;
